import React, {useEffect, useState} from 'react';
import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import TextFieldValidation from "../../../../../../components/UI/table/customer-detales/TextFieldValidation";
import {noExponents} from "../../../../../../utils/processing/noExponents";
import {SIDE} from "../../../../../../Constants";
import MenuItem from "@mui/material/MenuItem";
import ButtonExit from "../../../../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../../../../components/UI/button/ButtonAdd";
import {patternOrValue} from "../../../../../../utils/processing/patternOrValue";

const numericDepth = (depth) => {
    if (depth == null || depth === "") {
        return ""
    }
    return +parseFloat(noExponents(depth)).toFixed(2)
}

const buildInitFormState = (initData) => ({
    position: initData?.contour?.position || SIDE[0].value,
    depth: patternOrValue(initData?.variables, "DEPTH", numericDepth(initData?.depth)),
})

const NotchContour = ({
                          onClose,
                          onSubmit,
                          detailData,
                          editableElementId,
                          activePointId,
                          openConfirmModal
                      }) => {
    const notchId = editableElementId ?? activePointId
    const initData = detailData.notches?.find((contour) => contour.id === notchId)

    const [formState, setFormState] = useState(() => buildInitFormState(initData))
    const [validationState, setValidationState] = useState({depth: ""})

    useEffect(() => {
        const notch = detailData.notches?.find((contour) => contour.id === notchId)
        setFormState(buildInitFormState(notch))
        setValidationState({depth: ""})
    }, [notchId, detailData.notches])

    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(formState).forEach(([name, value]) => {
            if (value === "") {
                newErrors[name] = "пустое поле"
            }
        })

        setValidationState(newErrors)

        if (Object.values(newErrors).every((el) => el === "")) {
            onSubmit({position: formState.position, depth: formState.depth})
        }
    }

    if (!initData) {
        return (
            <>
                <DialogTitle textAlign="center">Изменить контур</DialogTitle>
                <DialogContent>
                    Контур не найден
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Отменить"} onClick={onClose}/>
                </DialogActions>
            </>
        )
    }

    return (<>
        <DialogTitle textAlign="center">Изменить контур</DialogTitle>
        <DialogContent style={{paddingBottom: 7}}>
            <FormControl sx={{minWidth: 300}}>
                <TextFieldValidation
                    select
                    name="position"
                    label="Позиция"
                    value={formState.position}
                    setCurrValues={setFormState}
                    setValidationState={setValidationState}
                >
                    {[SIDE[0], SIDE[1]].map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextFieldValidation>
                <TextFieldValidation
                    name={"depth"}
                    value={formState?.depth}
                    label="Глубина"
                    setCurrValues={setFormState}
                    validationError={validationState?.depth}
                    setValidationState={setValidationState}
                    adornment={numericDepth(initData.depth)}
                />
                <Button
                    size="small"
                    color="secondary"
                    onClick={() => openConfirmModal("deleteNotch", initData.id)}
                    variant="outlined"
                >
                    Удалить контур
                </Button>
            </FormControl>
        </DialogContent>
        <DialogActions sx={{p: '1.25rem'}}>
            <ButtonExit text={"Отменить"} onClick={onClose}/>
            <ButtonAdd text={"Выбрать"} onClick={handleValidationData}/>
        </DialogActions>
    </>)
}
export default NotchContour
